'use strict';

var implementation$1 = require('./implementation.js');

var implementation = implementation$1;

var functionBind = Function.prototype.bind || implementation;

module.exports = functionBind;
